import { Component } from '@angular/core';
import {LoginComponent} from "./login/login.component";
import {NotificationsComponent} from "../notifications/notifications.component";

@Component({
  selector: 'app-app-mkt',
  standalone: true,
    imports: [LoginComponent, NotificationsComponent],
  templateUrl: './app-mkt.component.html',
  styleUrl: './app-mkt.component.css'
})
export class AppMktComponent {

}
